/* eslint-disable no-restricted-globals */


import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader, CardBody, CardTitle, Row, Col, Alert, Input } from "reactstrap";
import useToken from "../../helpers/useToken"
import TMHLoader from "../TMHLoader/TMHLoader"
import Switch from "react-switch";

export default function RatingCategory({ notify }) {
    const { token } = useToken()

    const [isLoading, setIsLoading] = useState(false)
    const [ratingCategory, setRatingCategory] = useState();

    useEffect(() => {
        const initData = () => {
            console.log('RatingCategory: update data')
            setIsLoading(true)
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            fetch(process.env.REACT_APP_BASE_URL + "notification/config/rating", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        const json = result.json;
                        if (result.ok) {
                            setRatingCategory(json)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token])

    const handleSubmit = () => {
        console.log('RatingCategory: submit data')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify(ratingCategory)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/config/rating", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    var json = result.json
                    if (result.ok) {
                        notify('tl', 'Update Rating Notification success!', 'success')
                        setRatingCategory(json)
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Update Rating Notification failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    const sendTestToMobile = (_notificationConfig) => {
        console.log('RatingCategory: sendTestToMobile')
        setIsLoading(true)
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        myHeaders.append("Access-Token", token);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(_notificationConfig)
        }

        fetch(process.env.REACT_APP_BASE_URL + "notification/push_test", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    if (result.ok) {
                        notify('tl', 'Send Notification success!\n' + result.json.message, 'success')
                        setIsLoading(false)
                    }
                    else {
                        notify('tl', 'Send Notification failed!\n' + result.json.message, 'danger')
                        console.log(result.json.message)
                        setIsLoading(false)
                    }
                }
            )
    }

    return (
        <TMHLoader active={isLoading}>

            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h2">
                                {ratingCategory && ratingCategory.name}
                            </CardTitle>
                            {
                                ratingCategory &&
                                <CardBody>
                                    {
                                        ratingCategory.config.map((_notificationConfig, index) => {
                                            return (
                                                <>
                                                    <Row key={index}>
                                                        <Col md="2">
                                                            <Row>
                                                                <Alert style={{ "padding": 0, "margin": 0 }} color="warning">
                                                                    <Input
                                                                        style={{ "fontSize": 20 }}
                                                                        type="text"
                                                                        value={_notificationConfig.description}
                                                                        onChange={(e) => {
                                                                            var _category = { ...ratingCategory }
                                                                            _category.config[index].description = e.target.value
                                                                            setRatingCategory(_category)
                                                                        }}
                                                                    />
                                                                </Alert>
                                                            </Row>
                                                            <Alert style={{ marginTop: 10 }} color="default">
                                                                <Row>
                                                                    <Col md="12">
                                                                        <input
                                                                            style={{ "fontSize": 12 }}
                                                                            type="text"
                                                                            placeholder="Test MobileId"
                                                                            value={_notificationConfig.test_mobile_id}
                                                                            onChange={(e) => {
                                                                                var _category = { ...ratingCategory }
                                                                                _category.config[index].test_mobile_id = e.target.value
                                                                                setRatingCategory(_category)
                                                                            }}
                                                                        />
                                                                        </Col>
                                                                    <Col md="12">
                                                                        <div className="text-center"><Button size="sm" onClick={() => sendTestToMobile(_notificationConfig)}>Send Test</Button></div>
                                                                    </Col>
                                                                </Row>
                                                            </Alert>

                                                        </Col>

                                                        <Col md="5">
                                                            <p style={{ textAlign: "center" }}>Action on Mobile</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Open Link</b>
                                                                            <input
                                                                            style={{ "fontSize": 12, width: "100%" }}
                                                                            type="text"
                                                                            placeholder="Link"
                                                                            value={_notificationConfig.mobile_actions.OPEN_LINK}
                                                                            onChange={(e) => {
                                                                                var _category = { ...ratingCategory }
                                                                                _category.config[index].mobile_actions.OPEN_LINK = e.target.value
                                                                                setRatingCategory(_category)
                                                                            }}
                                                                        />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="10">
                                                                            <b>Image</b>
                                                                            <input
                                                                            style={{ "fontSize": 12, width: "100%" }}
                                                                            type="text"
                                                                            placeholder="Image URL"
                                                                            value={_notificationConfig.image}
                                                                            onChange={(e) => {
                                                                                var _category = { ...ratingCategory }
                                                                                _category.config[index].image = e.target.value
                                                                                setRatingCategory(_category)
                                                                            }}
                                                                        />
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>

                                                        <Col md="3">
                                                            <p style={{ textAlign: "center" }}>Message</p>
                                                            <Card>
                                                                <CardBody>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="4">
                                                                            <b>Title</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5, padding: 0 }} md="8">
                                                                            <Alert style={{ padding: 0 }} color="default" >
                                                                                <Input
                                                                                    style={{ padding: 5 }}
                                                                                    type="textarea"
                                                                                    value={_notificationConfig.title}
                                                                                    onChange={(e) => {
                                                                                        var _category = { ...ratingCategory }
                                                                                        _category.config[index].title = e.target.value
                                                                                        setRatingCategory(_category)
                                                                                    }}
                                                                                />
                                                                            </Alert>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col style={{ marginTop: 5 }} md="4">
                                                                            <b>Body</b>
                                                                        </Col>
                                                                        <Col style={{ marginTop: 5, padding: 0 }} md="8">
                                                                            <Alert style={{ padding: 0 }} color="default" >
                                                                                <Input
                                                                                    style={{ padding: 5 }}
                                                                                    type="textarea"
                                                                                    value={_notificationConfig.message}
                                                                                    onChange={(e) => {
                                                                                        var _category = { ...ratingCategory }
                                                                                        _category.config[index].message = e.target.value
                                                                                        setRatingCategory(_category)
                                                                                    }}
                                                                                />
                                                                            </Alert>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                        <Col style={{marginTop: -25}} md="4">
                                                        <Card>
                                                                <CardBody>
                                                                    
                                                                    <Row>
                                                                        <Col md="8" style={{ textAlign: "left", marginTop: 15 }} >
                                                                        <b>Send if criteria met: </b>
                                                                        </Col>
                                                                        <Col style={{ textAlign: "left", marginTop: 10 }} md="2">
                                                                            
                                                                        <Switch
                                                                            onChange={() => {
                                                                                var _category = { ...ratingCategory }
                                                                                _category.config[index].custom.CRITERIA_MET = !_notificationConfig.custom.CRITERIA_MET
                                                                                setRatingCategory(_category)
                                                                            }}
                                                                         checked={_notificationConfig.custom.CRITERIA_MET} />
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="1" />
                                                        <Col md="7" className="mb-4" style={{
                                                            "border": "1px solid"
                                                        }} />
                                                    </Row>
                                                </>)
                                        })
                                    }

                                    <div className="text-center"><Button onClick={() => handleSubmit()}>SAVE</Button></div>
                                </CardBody>
                            }
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}